// extracted by mini-css-extract-plugin
export var notificationHost = "_fa-0";